export class ConnectCustomerVaultAccountRequest {
    'name';
    'vaultAccountAttributes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultAccountAttributes",
            "baseName": "vaultAccountAttributes",
            "type": "AccountConfigInput",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectCustomerVaultAccountRequest.attributeTypeMap;
    }
    constructor() {
    }
}
